// ============================================
// OLD IMPLEMENTATION - USING GOONG MAPS
// Commented out - Now using Google Maps (see _ContactGoogleMaps.js)
// ============================================

// import goongjs from "@goongmaps/goong-js";
// goongjs.accessToken = "cJvat27s1SVh7qbbGYkhU2jfvsRuGekr29HQlja5";
import { validationRegex } from "./utils";

export default class Common {
  /* ===================================
   *  CONSTRUCTOR
   * =================================== */
  constructor() {
    this.bindEvents();
  }

  /* ===================================
   *  EVENTS
   * =================================== */
  bindEvents() {
    // MAP SETUP - COMMENTED OUT (Now using Google Maps)
    // if (document.querySelector("#hospital-map")) {
    //   this.HospitalMapSetup();
    // }

    // Contact form still active
    if (document.querySelector("#the-contact-form")) {
      this.ContactFormSetup();
    }
  }

  /* ===================================
   *  METHODS
   * =================================== */
  // CONTACT FORM METHODS
  ContactFormSetup() {
    const $contactForm = $("#the-contact-form");

    // Initial form validation
    this.validateContactFormRealtime();

    $contactForm.on("submit", (e) => {
      e.preventDefault();
      this.validateContactForm();
    });

    // Real-time validation on input change
    $contactForm.on(
      "input change",
      'input[name="name"], input[name="email"], input[name="phone"], input[name="subject"], textarea[name="message"]',
      () => {
        this.validateContactFormRealtime();
      }
    );
  }

  validateContactForm() {
    const $form = $("#the-contact-form");
    let isValid = true;

    // Clear all previous errors
    $form.find(".input-group").removeClass("err");
    $form.find(".err-msg").text("");

    // Get form values
    const formData = {
      name: $form.find('input[name="name"]').val().trim(),
      email: $form.find('input[name="email"]').val().trim(),
      phone: $form.find('input[name="phone"]').val().trim(),
      subject: $form.find('input[name="subject"]').val().trim(),
      message: $form.find('textarea[name="message"]').val().trim(),
    };

    // Validate Name (required)
    if (!formData.name) {
      this.showContactError(
        'input[name="name"]',
        HM_Variables.frontend_lang.validation.name_required
      );
      isValid = false;
    } else if (formData.name.length > 64) {
      this.showContactError(
        'input[name="name"]',
        HM_Variables.frontend_lang.validation.name_too_long
      );
      isValid = false;
    } else if (!validationRegex.nameRegex.test(formData.name)) {
      this.showContactError(
        'input[name="name"]',
        HM_Variables.frontend_lang.validation.name_invalid
      );
      isValid = false;
    }

    // Validate Email (required)
    if (!formData.email) {
      this.showContactError(
        'input[name="email"]',
        HM_Variables.frontend_lang.validation.email_required
      );
      isValid = false;
    } else if (formData.email.length > 100) {
      this.showContactError(
        'input[name="email"]',
        HM_Variables.frontend_lang.validation.email_too_long
      );
      isValid = false;
    } else if (!validationRegex.emailRegex.test(formData.email)) {
      this.showContactError(
        'input[name="email"]',
        HM_Variables.frontend_lang.validation.email_invalid
      );
      isValid = false;
    }

    // Validate Phone (required)
    if (!formData.phone) {
      this.showContactError(
        'input[name="phone"]',
        HM_Variables.frontend_lang.validation.phone_required
      );
      isValid = false;
    } else if (!validationRegex.phoneRegex.test(formData.phone)) {
      this.showContactError(
        'input[name="phone"]',
        HM_Variables.frontend_lang.validation.phone_invalid
      );
      isValid = false;
    }

    // Validate Subject (required)
    if (!formData.subject) {
      this.showContactError(
        'input[name="subject"]',
        HM_Variables.frontend_lang.validation.subject_required
      );
      isValid = false;
    } else if (formData.subject.length > 100) {
      this.showContactError(
        'input[name="subject"]',
        HM_Variables.frontend_lang.validation.subject_too_long
      );
      isValid = false;
    }

    // Validate Message (required)
    if (!formData.message) {
      this.showContactError(
        'textarea[name="message"]',
        HM_Variables.frontend_lang.validation.message_required
      );
      isValid = false;
    } else if (formData.message.length > 500) {
      this.showContactError(
        'textarea[name="message"]',
        HM_Variables.frontend_lang.validation.message_too_long
      );
      isValid = false;
    }

    // If all validations pass, submit the form
    if (isValid) {
      this.submitContactForm();
    }

    return isValid;
  }

  showContactError(inputSelector, message) {
    const $input = $(inputSelector);
    const $inputGroup = $input.closest(".input-group");

    $inputGroup.addClass("err");
    $inputGroup.find(".err-msg").text(message);
  }

  submitContactForm() {
    const $form = $("#the-contact-form");
    const formData = new FormData($form[0]);

    // Debug: Log form data
    console.log("Contact form data being sent:");
    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }

    // Add loading state
    const $submitBtn = $form.find('button[type="submit"]');
    const originalText = $submitBtn.text();

    // Disable submit button and show loading
    const processingText =
      HM_Variables.language === "vi" ? "Đang xử lý..." : "Processing...";
    $submitBtn.prop("disabled", true).text(processingText);

    // Clear any previous form errors
    this.hideContactFormError();

    // Submit form via AJAX
    $.ajax({
      url: HM_Variables.ajax_url,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
      success: (response) => {
        // Re-enable submit button
        $submitBtn.prop("disabled", false).text(originalText);

        if (response.success) {
          // Hide form and show thank you note
          this.showContactThankYouNote();

          // Reset form on success
          $form[0].reset();

          // Re-validate form to update button state
          this.validateContactFormRealtime();
        } else {
          // Error response
          this.showContactFormError("❌ " + response.data);
        }
      },
      error: (xhr, status, error) => {
        // Re-enable submit button
        $submitBtn.prop("disabled", false).text(originalText);

        // Debug: Log error details
        console.error("AJAX Error:", {
          status: xhr.status,
          statusText: xhr.statusText,
          responseText: xhr.responseText,
          responseJSON: xhr.responseJSON,
        });

        // Handle AJAX errors
        let errorMessage = "Lỗi kết nối. Vui lòng thử lại.";

        if (xhr.status === 400) {
          errorMessage =
            "Dữ liệu không hợp lệ. Vui lòng kiểm tra lại thông tin.";
        } else if (xhr.responseJSON && xhr.responseJSON.data) {
          errorMessage = xhr.responseJSON.data;
        } else if (xhr.status === 0) {
          errorMessage =
            "Không thể kết nối đến server. Vui lòng kiểm tra kết nối internet.";
        } else if (xhr.status === 500) {
          errorMessage = "Lỗi server. Vui lòng thử lại sau.";
        }

        this.showContactFormError("❌ " + errorMessage);
      },
    });
  }

  validateContactFormRealtime() {
    const $form = $("#the-contact-form");
    const $submitBtn = $form.find('button[type="submit"]');

    // Get form values
    const formData = {
      name: $form.find('input[name="name"]').val().trim(),
      email: $form.find('input[name="email"]').val().trim(),
      phone: $form.find('input[name="phone"]').val().trim(),
      subject: $form.find('input[name="subject"]').val().trim(),
      message: $form.find('textarea[name="message"]').val().trim(),
    };

    // Check if all required fields are filled
    const isFormValid =
      formData.name &&
      formData.email &&
      formData.phone &&
      formData.subject &&
      formData.message;

    // Enable/disable submit button
    if (isFormValid) {
      $submitBtn.prop("disabled", false).removeClass("disabled");
    } else {
      $submitBtn.prop("disabled", true).addClass("disabled");
    }
  }

  showContactFormError(message) {
    const $form = $("#the-contact-form");
    const $errorMsg = $form.find("#contact-primary-error-msg");

    $errorMsg.text(message).show();
  }

  hideContactFormError() {
    const $form = $("#the-contact-form");
    const $errorMsg = $form.find("#contact-primary-error-msg");

    $errorMsg.hide();
  }

  showContactThankYouNote() {
    const $form = $("#the-contact-form");
    const $thankYouNote = $(".thankyou-note");

    // Hide the form
    $form.hide();

    // Show the thank you note by adding active class
    $thankYouNote.addClass("active");
  }

  /* ===================================
   *  HOSPITAL MAP METHODS - COMMENTED OUT
   *  Now using Google Maps implementation in _ContactGoogleMaps.js
   * =================================== */

  /*
  HospitalMapSetup() {
    const map = new goongjs.Map({
      container: "hospital-map",
      style: "https://tiles.goong.io/assets/goong_map_web.json", // stylesheet location
      center: [107.0, 16.2], // starting position [lng, lat] - center of Vietnam
      zoom:
        window.innerWidth <= 640 ? 4 : window.innerWidth <= 1180 ? 4.4 : 5.2, // starting zoom based on screen width
    });

    // Store map instance for later use
    this.map = map;

    // Initialize markers array to track all markers
    this.markers = [];

    // Initialize filter state
    this.filterState = {
      currentBrandId: "all",
      searchKeyword: "",
    };

    // Handle brand filter clicks
    const brandItems = document.querySelectorAll(".brands-list .brands-item");
    brandItems.forEach((item) => {
      item.addEventListener("click", () => {
        // Remove active class from all items
        brandItems.forEach((brandItem) => {
          brandItem.classList.remove("active");
        });

        // Add active class to clicked item
        item.classList.add("active");
        // Get selected brand ID
        const selectedBrandId = item.getAttribute("data-brand-id");

        // Get all hospital items
        const hospitalItems = document.querySelectorAll(
          ".hospital-search-item"
        );

        // Update filter state
        this.filterState.currentBrandId = selectedBrandId;

        // Trigger search
        this.handleSearch();
      });
    });

    // Handle hospital search form
    const searchForm = document.getElementById("search-hospital-by-name-form");
    const searchInput = document.getElementById(
      "search-hospital-by-name-input"
    );

    searchForm.addEventListener("submit", (e) => {
      e.preventDefault();

      // Update search keyword
      this.filterState.searchKeyword = searchInput.value;

      // Trigger search
      this.handleSearch();
    });

    // Wait for map to load before adding markers
    map.on("load", () => {
      this.initializeHospitalMarkers();
    });
  }

  initializeHospitalMarkers() {
    // Get all hospital search items
    const hospitalItems = document.querySelectorAll(".hospital-search-item");

    // Add markers for all hospitals initially
    // Clear existing markers if any
    if (this.markers) {
      this.markers.forEach((marker) => marker.remove());
    }
    this.markers = [];

    // Create marker element
    const markerElement = document.createElement("div");
    markerElement.className = "mapboxgl-marker";
    markerElement.innerHTML = `<img src="${HM_Variables.assets_url}images/map-marker.png" alt="Hospital Marker">`;

    // khi nhấn vào item bên danh sách thì show ra marker
    hospitalItems.forEach((item) => {
      const latitude = parseFloat(item.getAttribute("data-lat"));
      const longitude = parseFloat(item.getAttribute("data-lng"));
      const hospitalName = item.querySelector(".hospital-name").textContent;
      const hospitalShortName = item.getAttribute("data-brand-shortname");

      // Validate coordinates
      if (
        !isNaN(latitude) &&
        !isNaN(longitude) &&
        latitude !== 0 &&
        longitude !== 0
      ) {
        const fixedCoords = this.validateAndFixCoordinates(latitude, longitude);
        if (fixedCoords) {
          this.addHospitalMarkerNoPopup(
            fixedCoords.longitude,
            fixedCoords.latitude,
            hospitalName,
            hospitalShortName
          );
        }
      }

      // Add click event listener to each hospital item
      item.addEventListener("click", (e) => {
        this.handleHospitalClick(e, item);
      });
    });
  }

  handleHospitalClick(e, item) {
    const latitude = parseFloat(item.getAttribute("data-lat"));
    const longitude = parseFloat(item.getAttribute("data-lng"));
    const hospitalId = item.getAttribute("data-hospital-id");
    const hospitalName = item.querySelector(".hospital-name").textContent;
    const hospitalShortName = item.getAttribute("data-brand-shortname");
    const hospitalAddress = item.querySelector(".hospital-address").textContent;

    // Check if coordinates are valid
    if (
      isNaN(latitude) ||
      isNaN(longitude) ||
      latitude === 0 ||
      longitude === 0
    ) {
      console.warn("Invalid coordinates for hospital:", hospitalName);
      return;
    }

    // Validate and fix coordinates if needed
    const fixedCoords = this.validateAndFixCoordinates(latitude, longitude);
    if (!fixedCoords) {
      console.error("Invalid coordinates for hospital:", hospitalName);
      return;
    }

    // Clear existing markers
    this.clearAllMarkers();

    // Create and add new marker - Note: setLngLat expects [longitude, latitude]
    this.addHospitalMarker(
      fixedCoords.longitude,
      fixedCoords.latitude,
      hospitalName,
      hospitalShortName,
      hospitalAddress
    );

    // Pan map to marker location - Note: center expects [longitude, latitude]
    this.map.flyTo({
      center: [fixedCoords.longitude, fixedCoords.latitude],
      zoom: 15,
      duration: 1000,
    });

    // Add active class to clicked item
    this.setActiveHospitalItem(item);
  }

  validateAndFixCoordinates(lat, lng) {
    // Check if coordinates are in valid ranges
    const isLatValid = lat >= -90 && lat <= 90;
    const isLngValid = lng >= -180 && lng <= 180;

    // If both are valid, return as is
    if (isLatValid && isLngValid) {
      return { latitude: lat, longitude: lng };
    }

    // If coordinates might be swapped, try swapping them
    if (!isLatValid && isLngValid) {
      // lat is actually longitude, lng is actually latitude
      if (lng >= -90 && lng <= 90 && lat >= -180 && lat <= 180) {
        console.warn("Coordinates appear to be swapped, fixing...");
        return { latitude: lng, longitude: lat };
      }
    }

    if (isLatValid && !isLngValid) {
      // lng is actually latitude, lat is actually longitude
      if (lng >= -90 && lng <= 90 && lat >= -180 && lat <= 180) {
        console.warn("Coordinates appear to be swapped, fixing...");
        return { latitude: lng, longitude: lat };
      }
    }

    // If we can't fix it, return null
    console.error("Invalid coordinates:", { lat, lng });
    return null;
  }

  addHospitalMarker(
    longitude,
    latitude,
    hospitalName,
    hospitalShortName,
    hospitalAddress
  ) {
    // Create popup content
    const popupContent = `
      <div class="hospital-popup">
        <h4 class="hospital-popup-name ${hospitalShortName}-name">${hospitalName}</h4>
        <p class="${hospitalShortName}-address">${hospitalAddress}</p>
      </div>
    `;

    // Create popup
    const popup = new goongjs.Popup({
      closeButton: true,
      closeOnClick: false,
      maxWidth: "300px",
    }).setHTML(popupContent);

    // Create marker
    const markerElement = document.createElement("div");
    markerElement.innerHTML = `<div class="mapboxgl-marker ${hospitalShortName}-marker img-holder">
        <img src="${HM_Variables.assets_url}img/icons/pin-${hospitalShortName}-lg-ico.svg">
      </div>`;

    const marker = new goongjs.Marker({
      element: markerElement,
      scale: 1.2,
      draggable: false,
    })
      .setLngLat([longitude, latitude])
      .setPopup(popup)
      .addTo(this.map);

    // Store marker reference
    this.markers.push(marker);

    // Automatically open popup and prevent map from jumping around
    // This fixes an issue where opening the Goong Map popup causes unwanted scrolling
    marker.getPopup().on("open", (e) => {
      // e.preventDefault();

      // Lock scroll at hospital map section
      const mapSection = document.querySelector(".section-hospital-map");
      // Prevent scrolling when popup is open
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      window.scrollTo(0, currentScrollPosition);
      if (mapSection) {
        const mapRect = mapSection.getBoundingClientRect();
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        const targetScrollPosition = scrollTop + mapRect.top;
        window.scrollTo({
          top: targetScrollPosition,
        });
      }
    });
    marker.togglePopup();
  }

  addHospitalMarkerNoPopup(
    longitude,
    latitude,
    hospitalName,
    hospitalShortName
  ) {
    const markerElement = document.createElement("div");
    markerElement.className = `mapboxgl-marker ${hospitalShortName}-marker img-holder`;
    markerElement.innerHTML = `<img src="${HM_Variables.assets_url}img/icons/pin-${hospitalShortName}-lg-ico.svg">`;
    const marker = new goongjs.Marker({
      element: markerElement,
      scale: 1.2,
      draggable: false,
    })
      .setLngLat([longitude, latitude])
      .addTo(this.map);

    // Store marker reference
    this.markers.push(marker);
  }

  clearAllMarkers() {
    // Remove all existing markers from map
    this.markers.forEach((marker) => {
      marker.remove();
    });

    // Clear markers array
    this.markers = [];
  }

  setActiveHospitalItem(activeItem) {
    // Remove active class from all items
    document.querySelectorAll(".hospital-search-item").forEach((item) => {
      item.classList.remove("active");
    });

    // Add active class to clicked item
    activeItem.classList.add("active");
  }

  handleSearch() {
    // Get all hospital items
    const hospitalItems = document.querySelectorAll(".hospital-search-item");

    hospitalItems.forEach((item) => {
      const itemBrandId = item.getAttribute("data-brand-id");

      const hospitalName = item
        .querySelector(".hospital-name")
        .textContent.toLowerCase();
      const searchTerm = this.filterState.searchKeyword.toLowerCase();

      // Check if item matches both brand filter and search keyword
      const matchesBrand =
        this.filterState.currentBrandId === "all" ||
        itemBrandId === this.filterState.currentBrandId;

      // Normalize Vietnamese text for case-insensitive comparison
      const normalizedHospitalName = hospitalName
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      const normalizedSearchTerm = searchTerm
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      const matchesSearch =
        normalizedHospitalName.includes(normalizedSearchTerm);

      // Show/hide based on combined conditions
      if (matchesBrand && matchesSearch) {
        item.classList.remove("hide");
      } else {
        item.classList.add("hide");
      }
    });

    // Filter markers on map based on current brand selection
    this.filterMarkersByBrand();
  }

  filterMarkersByBrand() {
    // Clear all existing markers
    this.clearAllMarkers();

    // Get all visible hospital items (after filtering)
    const visibleHospitalItems = document.querySelectorAll(
      ".hospital-search-item:not(.hide)"
    );

    // Add markers only for visible hospitals
    visibleHospitalItems.forEach((item) => {
      const latitude = parseFloat(item.getAttribute("data-lat"));
      const longitude = parseFloat(item.getAttribute("data-lng"));
      const hospitalName = item.querySelector(".hospital-name").textContent;
      const hospitalShortName = item.getAttribute("data-brand-shortname");

      // Validate coordinates
      if (
        !isNaN(latitude) &&
        !isNaN(longitude) &&
        latitude !== 0 &&
        longitude !== 0
      ) {
        const fixedCoords = this.validateAndFixCoordinates(latitude, longitude);
        if (fixedCoords) {
          this.addHospitalMarkerNoPopup(
            fixedCoords.longitude,
            fixedCoords.latitude,
            hospitalName,
            hospitalShortName
          );
        }
      }
    });

    // Zoom out to show all filtered markers - only if not showing all brands
    if (this.filterState.currentBrandId !== "all") {
      const zoomLevel =
        window.innerWidth <= 640 ? 4 : window.innerWidth <= 1180 ? 4.4 : 5.2;
      this.map.easeTo({
        zoom: zoomLevel,
        duration: 1000,
      });
    }
  }
  */
  // END OF COMMENTED OUT MAP METHODS
}
